import { trackOnboardingStarted } from '@zola-helpers/client/dist/es/tracking/onboard/onboardEvents';
import {
  BUSINESS_UNIT,
  COMPONENT,
} from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';

import {
  setOnboardAddToRegistryEventData,
  setOnboardAddToRegistryProductData,
  setOnboardRedirect,
  submitDefaultOnboarding,
} from '../../actions/OnboardActions';

import { getRegistryItemAddedEventData } from './helpers';

export const onAddToRegistry = (params, dispatchCallback) => {
  const {
    productData,
    activeSku,
    userContext,
    quantity,
    dispatch,
    addToRegistry,
    activeProductLook,
    location,
    section,
    extraData,
    personalizationData,
  } = params;

  return (carouselQuantity, carouselSkuId) => {
    if (!activeSku) {
      return null;
    }

    const skuId = activeSku.id;
    const request = {
      sku_id: skuId,
      enable_group_gifting: false,
      quantity,
    };

    const handleAddToRegistry = () => {
      // carousel values are only used in the main PDP to determine whether its the main product or a carousel product being added
      // they are not relevant to the kit product detail rows
      if (Number(carouselQuantity)) {
        request.quantity = carouselQuantity;
        request.sku_id = carouselSkuId;
        return dispatch(addToRegistry(request, productData.shipping_zones));
      }
      return dispatch(addToRegistry(request, productData.shipping_zones)).then(dispatchCallback);
    };

    if (personalizationData) {
      request.user_selection_uuid = personalizationData.uuid;
      request.sku_id = personalizationData.sku_id;
    }
    const automaticallyOnboardUser =
      !userContext.has_registry && userContext.has_completed_onboarding;
    if (automaticallyOnboardUser) {
      trackOnboardingStarted(BUSINESS_UNIT.WEDDING_REGISTRY, COMPONENT.REGISTRY);
      return dispatch(submitDefaultOnboarding()).then(() => {
        return handleAddToRegistry();
      });
    }
    if (!userContext.has_registry) {
      const eventData = getRegistryItemAddedEventData({
        productData,
        activeProductLook,
        activeSku,
        quantity,
        location,
        section,
        extraData,
      });
      dispatch(setOnboardAddToRegistryEventData(eventData));
      dispatch(setOnboardAddToRegistryProductData(request));
      dispatch(setOnboardRedirect(window.location.pathname));
      window.location.href = '/onboard/new';
      return null;
    }
    return handleAddToRegistry();
  };
};

export const onAddToCart = (params, dispatchCallback) => {
  const { activeSku, quantity, setQuantity, dispatch, addItemToCart, personalizationData } = params;
  return (carouselRequest) => {
    if (!activeSku) {
      return null;
    }
    const request = {
      sku_id: activeSku.id,
      quantity,
      item_origin: 'ECOMMERCE',
    };
    if (!carouselRequest.target) {
      request.sku_id = carouselRequest.sku_id;
      request.quantity = carouselRequest.quantity;
    }
    if (personalizationData) {
      request.user_selection_uuid = personalizationData.uuid;
      request.sku_id = personalizationData.sku_id;
    }
    return dispatch(addItemToCart(request))
      .then((response) => {
        dispatchCallback(response, request.quantity);
      })
      .catch((err) => {
        const { trigger } = err;
        if (err.category && err.category.reason === 'sku-unavailable' && Number(trigger) !== 0) {
          setQuantity(Number(trigger));
        }
      });
  };
};
